<template>
  <v-dialog
    v-model="dialog"
    persistent
    overlay-opacity="0"
    max-width="290"
  >
    <v-card>
      <v-card-title v-if="title">
        <b>{{ title }}</b>
      </v-card-title>
      <v-card-text v-if="detail">
        {{ detail }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          text
          @click="cancel()"
          class="os-rounded"
        >
          <b>{{$t('basics.cancel')}}</b>
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="handler()"
          class="os-rounded"
        >
          <b>{{ action }}</b>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'

@Component({
  props: {
    title: {
      type: String,
      default: null
    },
    detail: {
      type: String,
      default: null
    },
    action: {
      type: String,
      default: 'Confirmar'
    },
    globalExit: {
      type: Boolean,
      default: false
    }
  }
})
export default class Confirm extends Vue {
  data () {
    return {
      dialog: false
    }
  }

  toggleConfirm () {
    this.dialog = !this.dialog
  }

  cancel () {
    this.dialog = false
    this.ococGoogleAnalyticsCancel()
  }

  handler () {
    if (this.globalExit) {
      this.ocGoogleAnalyticsGlobalExit()
    }

    this.dialog = false
    this.$emit('confirmHandler')
  }
d
  ocGoogleAnalyticsGlobalExit () {
    OcGoogleAnalytics.getDataLayerConfig('global-exit', false)
  }

  ococGoogleAnalyticsCancel () {
    OcGoogleAnalytics.getDataLayerConfig('cancel.modal')
  }
}
</script>
